export default __webpack_public_path__ + "3695a718ba69dbbe2409d48dea62f5cc.svg";